import React from 'react';
// Final Thank You Email for unregistered participants
const TwentyOneStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    photo_access_link,
    upcoming_conference_link,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        <strong>Dear {client_name ? client_name : `[Client Name]`},</strong>
      </p>

      <p>
        Thank you for showing interest in{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>
        ! Although we missed the chance to have you with us at this edition, we
        truly value your engagement and would love to keep you connected with
        our growing academic community.
      </p>

      <p>
        We’re excited to share a few highlights from the conference that
        captured the spirit of collaboration, innovation, and impactful
        research:
      </p>

      <p>
        📸 View Conference Moments:{' '}
        {photo_access_link ? (
          <a href={photo_access_link} target="_blank" rel="noopener noreferrer">
            Click Here
          </a>
        ) : (
          `[Photos Access Link]`
        )}
        <br />
        (Relive the energy, key moments, and vibrant exchange of ideas!)
      </p>

      <p>
        The good news? There’s always a next time! We warmly invite you to be
        part of our <strong>upcoming conference</strong> where you’ll have
        another chance to showcase your research, engage with global experts,
        and contribute to meaningful academic discussions.
      </p>

      <p>
        🎓 Explore Upcoming Conferences & Register Here:{' '}
        {upcoming_conference_link ? (
          <a
            href={upcoming_conference_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Click Here
          </a>
        ) : (
          `[Upcoming Conference
        Link]`
        )}
      </p>
      <p>
        We’d be honored to welcome you next time and support your journey toward
        global academic recognition.
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default TwentyOneStepTemplate;
